export const findIngestionSettingsResponseDtoTraceabilityMethod = {
  DEFAULT: "DEFAULT",
  PO: "PO",
  MULTISOURCING: "MULTISOURCING",
} as const
export type FindIngestionSettingsResponseDtoTraceabilityMethod =
  (typeof findIngestionSettingsResponseDtoTraceabilityMethod)[keyof typeof findIngestionSettingsResponseDtoTraceabilityMethod]
export type FindIngestionSettingsResponseDto = {
  /**
   * @type string
   */
  traceabilityMethod: FindIngestionSettingsResponseDtoTraceabilityMethod
  /**
   * @type array
   */
  defaultStandards: string[]
}
